// 埋点模块统一导出

// 组件
export { GlobalTracker } from "./global-tracker"
export { ScrollDepthTracker } from "./scroll-depth-tracker"
// 配置
export {
	generateCommonProperties,
	generateEventProperties,
	getActionEventProperties,
	getBaseProperties,
	getClickEventProperties,
	getEventTypeProperties,
	getIsFirstDay,
	getViewEventProperties,
	TRACKING_CONFIG,
	TrackingEventType,
} from "./tracking-config"
// Hooks
export { useTracking } from "./tracking-hooks"

// 导入类型用于接口定义
import type { TrackingEventType } from "./tracking-config"

// GTM 埋点
export {
	consentUpdate,
	GTM_CONTAINER_ID,
	type Item,
	initDataLayer,
	pageLoad,
	pushToDataLayer,
	trackAddToCart,
	trackAddToWishlist,
	trackBeginCheckout,
	trackDownloadType,
	trackLogin,
	trackProceedToPay,
	trackPurchase,
	trackRemoveFromWishlist,
	trackSearch,
	trackSelectPromotion,
	trackSignUp,
	trackSubscription,
	trackViewCart,
	trackViewItem,
	trackViewPromotion,
} from "./gtm"

// 埋点服务
export { TrackReportState, trackService } from "./track-service"
// 工具函数
export {
	getClickElementInfo,
	getClickProperties,
	getCurrentPageInfo,
	getPageLeaveProperties,
	getPageViewProperties,
	parseUrlInfo,
} from "./tracking-utils"

// 类型定义
export interface TrackingEvent {
	name: string
	properties?: Record<string, any>
	eventType?: TrackingEventType
}

export interface GlobalProperties {
	[key: string]: any
}
